export default function ProtectImage({
  src,
  alt = '',
  className = '',
  fill = false, // MODE: true = isi penuh (pakai di thumbnail), false = natural
}) {
  const handleContextMenu = (e) => e.preventDefault();
  const handleDragStart = (e) => e.preventDefault();

  return (
    <div
      className={`relative w-full select-none ${fill ? 'h-full' : ''}`}
      onContextMenu={handleContextMenu}
      onDragStart={handleDragStart}
    >
      <img
        src={src}
        alt={alt}
        draggable="false"
        className={
          fill
            ? `absolute inset-0 w-full h-full object-cover pointer-events-none ${className}`
            : `pointer-events-none w-full h-auto ${className}`
        }
      />

      {/* Overlay anti-download */}
      <div className="absolute inset-0 bg-transparent pointer-events-auto"></div>
    </div>
  );
}
